import React from 'react';
import './ProgressBar.css';

export default function ProgressBar({ value = 0, max = 100, height = 8, showLabel = false }) {
  const pct = Math.min(100, Math.max(0, Number(value)));
  const style = { height: typeof height === 'number' ? `${height}px` : height };

  return (
    <div className="progress-bar-wrap">
      <div className="progress-bar" style={style}>
        <div
          className="progress-bar-fill"
          style={{ width: `${pct}%` }}
          role="progressbar"
          aria-valuenow={value}
          aria-valuemin={0}
          aria-valuemax={max}
        />
      </div>
      {showLabel && <span className="progress-bar-label">{Math.round(pct)}%</span>}
    </div>
  );
}
